import PrintIcon from '@material-ui/icons/Print';

import List from './List';

export default {
  list: List,
  icon: PrintIcon,
};
